import React from 'react';

export default function NbnlNotSupportedContent() {
  return (
    <>
      No box or Label is currently available via UPS by ShipStation. Please
      activate the Wallet first before using this service.
    </>
  );
}
